import { UserDataResponse, UserState } from '@/interfaces/user';
import { AvailableLoan } from '@/interfaces/loan';
import { setLoanNumber } from '@/storage';

function shouldUpdateActiveLoanNumber(
  activeLoanNumber: string | null,
  loans: AvailableLoan[]
): boolean {
  // check if activeLoanNumber stored in localstorage does not match any of the loans
  if (activeLoanNumber && !loans.some(l => l.loan_number === activeLoanNumber)) {
    return true;
  }

  return activeLoanNumber === null && loans.length === 1;
}

export function setUserState(state: UserState, userInfo: UserDataResponse) {
  state.ach_provider = userInfo.ach_provider;
  state.has_payment_method = userInfo.has_payment_method;
  state.loans = userInfo.loans;
  state.email = userInfo.email;

  if (shouldUpdateActiveLoanNumber(state.activeLoanNumber, state.loans)) {
    state.activeLoanNumber = userInfo.loans[0].loan_number;
    setLoanNumber(userInfo.loans[0].loan_number);
  }
}

export function setActiveLoan(state: UserState, loan_number: string) {
  state.activeLoanNumber = loan_number;
  setLoanNumber(loan_number);
}

export function setIsFirstLogin(state: UserState, isFirstLogin: boolean) {
  state.isFirstLogin = isFirstLogin;
}
